import * as React from "react";

import "./receipt-route.scss";

import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {Load}           from "@Common/react/load";
import {Receipt}        from "@Xpresso/routes/customize/steps/done/receipt/receipt";

export const ReceiptRoute = ({match}) => cs(
    consumeContext("apis"),
    ["cart", ({apis}, next) => Load({
        fetch: () => apis.next.cart.getCart(match.params.cart_id),
        next,
    })],
    ({cart}) => (
        <div className="receipt-route-t53">
            {!cart ? (
                <div className="loading">
                    Loading cart receipt...
                </div>
            ) : cart.errors ? (
                <div className="error">
                    {cart.errors.msg}
                </div>
            ) : isPendingCart(cart.status) ? (
                <div className="error">
                    This cart has not been checked out.
                </div>
            ) : (
                <div className="container">
                    {Receipt({cart, printReceipt: false})}
                </div>
            )}
        </div>
    )
);

const isPendingCart = (status) => status === "pending" || status === "processing" || status === "pending approval";